export default __webpack_public_path__ + "static/media/ZillaSlab-SemiBold.96555be9.ttf";